import { render, staticRenderFns } from "./showrequets.vue?vue&type=template&id=db9e4cb2&scoped=true&"
import script from "./showrequets.vue?vue&type=script&lang=js&"
export * from "./showrequets.vue?vue&type=script&lang=js&"
import style0 from "./showrequets.vue?vue&type=style&index=0&id=db9e4cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9e4cb2",
  null
  
)

export default component.exports